import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type JobQueryVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type JobQuery = { __typename?: 'Query', job?: { __typename?: 'Job', id: number, status: string, result?: string | null, progress: number, category: string } | null };

export const JobDocument = gql`
    query Job($id: Int!) {
  job(id: $id) {
    id
    status
    result
    progress
    category
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JobGQL extends Apollo.Query<JobQuery, JobQueryVariables> {
    document = JobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }